module.exports = __webpack_public_path__ + "media/src/images/step-02-6bda115d2daaab3b8af73fd3c2105f4a.svg";